import { flow } from "mobx";
import { applySnapshot, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import { ITechnicalAssistModel, TechnicalAssistModel } from "./TechnicalAssistModel";
import technicalAPI from "./TechnicalAssistService";

export const TechnicalAssistListModel = types
    .model("TechnicalAssistListModel", {
        list: types.optional(types.array(TechnicalAssistModel), []),
        per_page: types.optional(types.number, 6),
        error: types.optional(ErrorModel, {}),
    })
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        getTechnicalAssist: flow(function*() {
            try {
                const result = yield technicalAPI.get();
                self.setField({
                    fieldname: "list",
                    value: result.data,
                });
            } catch (e) {
                self.setError(e);
                throw e;
            }
        }),
        getMoreTechnicalAssists: flow(function*() {
            try {
                const result = yield technicalAPI.get();
                self.addTechnicalAssist(result.data);
            } catch (e) {
                self.setError(e);
                throw e;
            }
        }),
        setError: (e: any) => {
            self.error.tigger = true;
            self.error.code = e.code;
            self.error.title = e.name;
            self.error.message = e.message;
            self.error.technicalStack = e.technicalStack;
        },
        addTechnicalAssist: (item: ITechnicalAssistModel[]) => {
            self.list.push(...item);
        },
        resetAll: () => {
            applySnapshot(self, {});
        },
    }));
export type ITechnicalAssistListModel = typeof TechnicalAssistListModel.Type;
